import { AddressDetails } from '../@types/ValidateZipCode'
import { FormAddressValuesProps } from '../Components/OwnerData/components/AddressForm'
import { concatenateObjectValuesWithoutComma } from './address'

export const streetNameFormatted = (streetName: string, streetType: string) => {
  const streetNameArray = streetName.split(' ')

  if (
    streetType.trim().toLowerCase() !==
    streetNameArray?.[0].trim().toLowerCase()
  ) {
    return streetName
  }

  const streetNameFormatted = streetNameArray
    .slice(1, streetNameArray.length)
    .join(' ')

  return streetNameFormatted
}

export const streetNameFormattedFromZipCode = (
  address: AddressDetails,
  isAnimalAddress?: boolean,
) => {
  let addressFormatted = address?.address || ''
  const arteryTypeAbbreviated = address?.arteryTypeAbbreviated || ''
  const arteryTitleAbbreviated = address?.arteryTitleAbbreviated || ''

  const streetSegmentType =
    address?.streets?.[0]?.streetSegment?.streetSegmentType || ''
  const streetSegmentTitle =
    address?.streets?.[0]?.streetSegment?.streetSegmentTitle || ''

  if (addressFormatted.includes(streetSegmentType) && !isAnimalAddress) {
    addressFormatted = addressFormatted.replace(
      streetSegmentType,
      arteryTypeAbbreviated,
    )
  }

  if (addressFormatted.includes(streetSegmentTitle)) {
    addressFormatted = addressFormatted.replace(
      streetSegmentTitle,
      arteryTitleAbbreviated,
    )
  }

  return addressFormatted
}

export const orderAddress = [
  'entityTypeArteria',
  'entityNameArteria',
  'entityNumberPolice',
  'entityNumberDoor',
  'entityFloor',
  'entityComplement',
]

export const truncateAddress = (
  addressValues: FormAddressValuesProps,
  key: string,
): FormAddressValuesProps => {
  const cloneAddressValue = { ...addressValues }
  const totalMaxLength = 50
  const truncateString = (textRaw: string, amountToTruncate: number) =>
    textRaw.slice(0, amountToTruncate)
  const fullAddressLength = concatenateObjectValuesWithoutComma(
    cloneAddressValue,
    orderAddress,
  ).length

  if (fullAddressLength >= totalMaxLength + 1) {
    const addressKey = cloneAddressValue?.[key as never] || ''
    const totalToRemove = fullAddressLength - totalMaxLength
    const addressKeyTruncated = truncateString(addressKey, -totalToRemove)
    const fullAddressTruncated = {
      ...cloneAddressValue,
      [key]: addressKeyTruncated.trim(),
    }

    const addressTruncated = concatenateObjectValuesWithoutComma(
      fullAddressTruncated,
      orderAddress,
    )

    if (addressTruncated.length >= totalMaxLength + 1) {
      return truncateAddress(fullAddressTruncated, 'entityNameArteria')
    }

    return fullAddressTruncated
  }

  return cloneAddressValue
}
